import SimpleWorkClientRepresentativeAPIResponse from "work/entities/entity-client-representative/api/response-contracts/simple-work-client-representative-api-response";
import SimpleWorkVendorTeamAPIResponse from "work/values/vendor-team/api/response-contracts/simple-work-vendor-team-api-response";
import WorkProposalAPIResponse from "work/entities/proposal/api/response-contracts/work-proposal-api-response";

export default class SimpleWorkProposalAPIResponse extends WorkProposalAPIResponse {
    declare client: SimpleWorkClientRepresentativeAPIResponse;
    declare vendorTeam: SimpleWorkVendorTeamAPIResponse;
    declare supersededBy?: SimpleWorkProposalAPIResponse;
}
